import { render, staticRenderFns } from "./conservationHeroes.vue?vue&type=template&id=b96538c8&scoped=true&"
import script from "./conservationHeroes.vue?vue&type=script&lang=js&"
export * from "./conservationHeroes.vue?vue&type=script&lang=js&"
import style0 from "./conservationHeroes.vue?vue&type=style&index=0&id=b96538c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96538c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VFlex,VIcon,VImg,VLayout,VSnackbar})
